export default "__VITE_ASSET__STK4GTpX__"